import { useWorkspace } from '@/features/workspaces/hooks';
import { DonutChart, DonutChartItem, DonutChartLegend } from '@/lib';
import { DataSourceIDEnum } from '@/models/dataSource';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HomeDataSectionChart } from '../../../common';

export const DataSourcesDistributionChart: FC = () => {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  const { data: metrics } = useGetWorkspaceMetricsQuery({ workspaceId: workspace.id });

  const chartData = useMemo<DonutChartItem[]>(() => {
    const sortedEntries = Object.entries(metrics.dataSourceSize ?? {}).sort(([, valueA], [, valueB]) => valueB - valueA);

    return sortedEntries.map(([key, value], index) => {
      const colorLevel = Math.max(100, 800 - index * 100);

      return {
        name: t(`data_sources:catalog.${key as DataSourceIDEnum}.title`),
        value,
        color: `var(--brand-${colorLevel})`,
      };
    });
  }, [metrics.dataSourceSize]);

  return (
    <HomeDataSectionChart title='home.dataSourcesDistribution'>
      <div className='flex gap-4'>
        <DonutChart data={chartData} className='size-52 shrink-0' />
        <DonutChartLegend data={chartData} />
      </div>
    </HomeDataSectionChart>
  );
};
